import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding: 24px 16px 48px;
    gap: 24px;

    @media (max-width: 480px) {
        padding: 16px 12px 32px;
        gap: 16px;
    }
`;
